import { Route } from '@angular/router';
import { guestGuard } from './core/guest.guard';
import { superAdminGuard } from './core/super-admin.guard';
import { unauthorizedGuard } from './core/unauthorized.guard';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.AdminLoginComponent),
    canActivate: [guestGuard],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent,
      ),
    canActivate: [unauthorizedGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./shared/layout/layout').then((m) => m.AdminLayoutComponent),
    canActivate: [superAdminGuard],
    children: [
      { path: '', redirectTo: 'tenants', pathMatch: 'full' },
      {
        path: 'tenants',
        loadComponent: () =>
          import('./pages/tenants/tenants.component').then((m) => m.TenantsComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/users/users.component').then((m) => m.AdminUsersComponent),
      },
      {
        path: 'users/:userId/permissions',
        loadComponent: () =>
          import('./pages/users/user-permissions.component').then((m) => m.AdminUserPermissionsComponent),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/roles/roles.component').then((m) => m.AdminRolesComponent),
      },
      {
        path: 'roles/:roleId/permissions',
        loadComponent: () =>
          import('./pages/roles/role-permissions.component').then((m) => m.AdminRolePermissionsComponent),
      },
      {
        path: 'permissions',
        loadComponent: () =>
          import('./pages/permissions/permissions.component').then((m) => m.PermissionsComponent),
      },
      {
        path: 'api-keys',
        loadComponent: () =>
          import('./pages/api-keys/api-keys.component').then((m) => m.ApiKeysComponent),
      },
      {
        path: 'impersonation-sessions',
        loadComponent: () =>
          import('./pages/impersonation-sessions/impersonation-sessions.component').then(
            (m) => m.ImpersonationSessionsComponent,
          ),
      },
      {
        path: 'mcp-access',
        loadComponent: () =>
          import('./pages/mcp-access/mcp-access.component').then((m) => m.McpAccessComponent),
      },
      {
        path: 'api-keys/:apiKeyId/permissions',
        loadComponent: () =>
          import('./pages/api-keys/api-key-permissions.component').then(
            (m) => m.AdminApiKeyPermissionsComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'tenants' },
];
